import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { Metamodel } from '../base/model';
import { format } from 'app/shared/utils/string.util';
import { DynamicsLinkedService } from './dynamics.linkedservice';

@Metamodel.model({
    name: adfModelTypeMap.commonDataService.linkedServiceType,
    display: [
        format(stringResources.ModelName_LinkedServiceTemplate, stringResources.CommonDataService_DisplayText),
        format(stringResources.ModelName_LinkedServicesTemplate, stringResources.CommonDataService_DisplayText)
    ]
})
export class CommonDataServiceLinkedService extends DynamicsLinkedService {
}
